export function formatStringData(data: string) {
   const dia = data.split('/')[0];
   const mes = data.split('/')[1];
   const ano = data.split('/')[2];

   return ano + '-' + ('0' + mes).slice(-2) + '-' + ('0' + dia).slice(-2);
}
